import { motion } from "framer-motion";
import { PlayCircle } from "lucide-react";

const PRESENTATION_ID = "njWQg3nwzfk";

export const PresentationVideo = () => {
  return (
    <section
      id="presentation"
      data-testid="presentation-video-section"
      className="relative py-20 md:py-28 px-6 md:px-12 lg:px-24 bg-black border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center_top,rgba(212,175,55,0.12),transparent_60%)]" />

      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto mb-10"
        >
          <span className="eyebrow inline-flex items-center gap-2">
            <PlayCircle size={13} /> Présentation
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Découvrez <span className="gold-text-gradient">qui je suis</span> en 2 minutes.
          </h2>
          <p className="mt-4 text-zinc-400 leading-relaxed">
            Une vidéo pour comprendre ma façon de travailler, mon approche du
            métier de DJ et la qualité que je mets dans chaque événement.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
          className="relative rounded-3xl overflow-hidden border border-[#D4AF37]/30 gold-glow bg-black"
        >
          <div className="aspect-video w-full relative">
            <iframe
              src={`https://www.youtube.com/embed/${PRESENTATION_ID}?rel=0&modestbranding=1`}
              title="Présentation – DJ AS Animation / Adrien Sebert"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              loading="lazy"
              data-testid="presentation-video-iframe"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
